import React, { useState } from "react";
import { IntlProvider } from "react-intl";
import EnglishUS from "../../features/language/en-US.json";
import EnglishCA from "../../features/language/en_CA.json";
import FrenchCA from "../../features/language/fr-ca.json";
//import SpanishMX from "../features/language/es-MX.json"
import { useDispatch, useSelector } from "react-redux";
import { LOCALES } from "../../features/language/locales";
import { setUser } from "../../features/userprofile/userSlice";
import log from '../components/Logger'
export const LanguageContext = React.createContext();


const LanguageWrapper = (props) => {

    let lang;
    const local = navigator.language;
    const userDetails = useSelector((state) => state.user.data.payload);
    let userDetailsCopy = {...userDetails};
    const ApiList = useSelector((state) => state.apiList.apiList);
    const dispatch = useDispatch();
    const idToken=localStorage.getItem("idToken")

    

    if (localStorage.getItem('locale') !== null || localStorage.getItem('locale') === "") {
        if (localStorage.getItem('locale') === LOCALES.ENGLISH_US) {
            lang = EnglishUS;
        } else if (localStorage.getItem('locale') === LOCALES.ENGLISH_CA) {
            lang = EnglishCA;
        } else {
            lang = FrenchCA;
        }
    } else {
        if (local === LOCALES.ENGLISH_US) {
            lang = EnglishUS;
        } else if (local === LOCALES.ENGLISH_CA) {
            lang = EnglishCA;
        } else {
            lang = FrenchCA;
        }
    }

    function postSetupLanguage(prefLang) {

        const update = {
            userProfile: {
                userId: userDetails.userId,
                preferredLanguage: prefLang,
                favorites: "1"
            }
        }
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'guid': `${ApiList.guid}`
            },
            body: JSON.stringify(update)
        };

        fetch(ApiList.setuplanguage, requestOptions)
            .then(res => {
                if (res.ok) {
                    log.info(`fos_ui_log: LanguageWrapper()postSetupLanguage: Preferred Language is updated to: ${prefLang}`)
                } else {
                    log.info(`fos_ui_log: LanguageWrapper()postSetupLanguage Unsuccessful Update: ${prefLang}`)
                }
            })
            .then(data => data)
            .catch(error => console.log('error', error))
    }


    const [locale, setLocale] = useState(local);
    const [messages, setMessages] = useState(lang);

    function selectLang(e) {
        localStorage.setItem('locale', e.target.value)
        const newLocale = e.target.value;
        setLocale(newLocale);
        let Language;
        
        if (newLocale === LOCALES.ENGLISH_US) {
            setMessages(EnglishUS);
            Language = 'English';
            userDetailsCopy.preferredLanguage = Language;
            dispatch(setUser(userDetailsCopy));
            postSetupLanguage(Language);

        } else if (newLocale === LOCALES.ENGLISH_CA) {
            setMessages(EnglishCA);
            Language = 'English-CA';
            userDetailsCopy.preferredLanguage = Language;
            dispatch(setUser(userDetailsCopy));
            postSetupLanguage(Language);
        }
        /*else if(newLocale === LOCALES.SPANISH_MX) {
            setMessages(SpanishMX);
            let Language = 'Spanish-MX';
            user.postSetupLanguage(Lang, userId);
        }*/
        else {
            if (newLocale === LOCALES.FRENCH_CA) {
                setMessages(FrenchCA);
                Language = 'French';
                userDetailsCopy.preferredLanguage = Language;
                console.log("User Details");
                console.log(userDetailsCopy);
                dispatch(setUser(userDetailsCopy));
                postSetupLanguage(Language);
            }
        }
    }
    return (
        <LanguageContext.Provider value={{ locale, selectLang }}>
            <IntlProvider messages={messages} locale={locale}>
                {props.children}
            </IntlProvider>
        </LanguageContext.Provider>

    )
}

export default LanguageWrapper